import React from 'react'
import _ from 'lodash'
export enum WeightUnitsEnum {
  KG = 'kg',
  G = 'g',
}

interface Props {
  value: number
  sourceUnits: WeightUnitsEnum
  units: WeightUnitsEnum
}
const FormattedWeight: React.FC<Props> = ({ value, sourceUnits, units = WeightUnitsEnum.KG }) => {
  let convertedValue = value
  if (sourceUnits === WeightUnitsEnum.KG) {
    convertedValue = value * 1000
  }
  if (units === WeightUnitsEnum.G) {
    return <>{_.round(convertedValue)}</>
  }
  return <>{_.round(convertedValue / 1000, 3)}</>
}

export default FormattedWeight
